import React, {useState} from "react";
import SideNavUx from "../../layout/sidenav";
import NavBarUx from "../../layout/navbar";
import FooterUx from "../layout/footer_ux";
import {
    Button,
    Input,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Typography,
    Select,
    Option, Menu, MenuHandler, IconButton, MenuList, MenuItem,
} from "@material-tailwind/react";
import {MagnifyingGlassIcon} from "@heroicons/react/24/solid";
import MapComponentUx from "../shared/MapComponentUx";

const Payments = () => {
    const [openSidenav, setOpenSidenav] = useState(false);
    const [step, setStep] = useState(1);
    const [searchType, setSearchType] = useState("search_by_name");
    const [clavePredio, setClavePredio] = useState("");
    const [name, setName] = useState("");
    const [pLastName, setPLastName] = useState("");
    const [mLastName, setMLastName] = useState("");
    const [selectedAdeudos, setSelectedAdeudos] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [recibido, setRecibido] = useState(0);
    const [prediosList, setPrediosList] = useState(null);
    const [predio, setPredio] = useState(null);
    const [error, setError] = useState(null);
    const [adeudos, setAdeudos] = useState(null);

    const [openResetDialog, setOpenResetDialog] = useState(false);
    const [openWarningDialog, setOpenWarningDialog] = useState(false);

    const totalSelected = selectedAdeudos.reduce(
        (acc, adeudo) => acc + adeudo.total,
        0
    );
    const totalSelectedRounded = Math.ceil(totalSelected);

    const handleBuscar = async () => {
        if (searchType === "search_by_cve") {
            if (clavePredio.trim() === "") return setError("Ingrese una clave válida");

            try {
                const response = await fetch(`/lots/${clavePredio}/search_by_code.json`);

                if (!response.ok) {
                    setError("No se encontraron datos para este código.");
                    setStep(1);
                    return;
                }

                const data = await response.json();
                setPredio(data);
                await loadDebts();
            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }

            setStep(2);
        } else if (searchType === "search_by_name") {
            if (name.trim() === "") return alert("Ingrese un nombre válido");

            try {
                const response = await fetch(`/lots/search_by_name?name=${name}&parental_last_name=${pLastName}&maternal_last_name=${mLastName}`);
                const data = await response.json();
                setPrediosList(data);
            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }
    };

    const handleReset = () => {
        setStep(1);
        setClavePredio("");
        setSelectedAdeudos([]);
        setPrediosList(null);
        setPredio(null);
        setPaymentMethod("");
        setName("");
        setPLastName("");
        setMLastName("");
        setRecibido(0);
        setOpenResetDialog(false);
        setAdeudos(null);
        setError(null);
    };

    const toggleAdeudo = (adeudo) => {
        setSelectedAdeudos((prev) =>
            prev.some((item) => item.id === adeudo.id)
                ? prev.filter((item) => item.id !== adeudo.id)
                : [...prev, adeudo]
        );
    };

    const handlePagar = () => {
        if (selectedAdeudos.length === 0) {
            setOpenWarningDialog(true);
        } else {
            setStep(3);
        }
    };

    const calcularCambio = () => (recibido - totalSelectedRounded).toFixed(2);

    const handleSelectPredio = async (predio) => {
        setClavePredio(predio.parcel_code);

        try {
            const response = await fetch(`/lots/${clavePredio}/search_by_code.json`);

            if (!response.ok) {
                setError("No se encontraron datos para este código.");
                setStep(1);
                return;
            }

            const data = await response.json();
            setPredio(data);
            await loadDebts();
        } catch (err) {
            console.error("Error al buscar el predio:", err);
        }

        setStep(2);
    };

    const loadDebts = async () => {
        try {
            const response = await fetch(`/lots/${clavePredio}/debts.json`);

            if (!response.ok) {
                console.log("No se encontraron datos para este código.");
            } else {
                const data = await response.json();
                setAdeudos(data);
                setSelectedAdeudos(data);
            }
        } catch (err) {
            console.error("Error al buscar el predio:", err);
        }
    };

    const handlePayment = async () => {
        console.log(selectedAdeudos);
        console.log(totalSelected);
        console.log(totalSelectedRounded);
        console.log(predio);
        console.log(clavePredio);
    }

    return (
        <>
            <SideNavUx setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
            <div className="p-4 xl:ml-80">
                <NavBarUx
                    routes={{main: "Inicio", current: "Pagos"}}
                    setOpenSidenav={setOpenSidenav}
                    openSidenav={openSidenav}
                />
                <div className="min-w-screen min-h-screen py-5">
                    <div className="w-full bg-white border-gray-200 px-5 py-10 text-gray-800">
                        {step === 1 && (
                            <>
                                <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                    PAGO DE PREDIAL
                                </h6>
                                <div className="mb-6">
                                    <div className="flex gap-4 items-center bg-gray-100 p-4 rounded">
                                        <span className="text-lg font-bold whitespace-nowrap pr-4">Búsqueda por:</span>
                                        <Select
                                            value={searchType}
                                            onChange={(e) => setSearchType(e)}
                                            className="w-full"
                                        >
                                            <Option value="search_by_cve">Clave catastral</Option>
                                            <Option value="search_by_name">Nombre y Apellidos</Option>
                                        </Select>
                                    </div>
                                    <div className="mt-4 bg-white p-6 rounded shadow-md">
                                        {searchType === "search_by_cve" && (
                                            <section id="find_by_cve">
                                                <div
                                                    className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                    <div>
                                                        <h1 className="font-bold text-lg">BUSQUEDA POR PREDIO</h1>
                                                        <p className="text-sm text-gray-500">
                                                            Ingresa la clave catastral para buscar.
                                                        </p>
                                                        {error && <p style={{color: "red"}}>{error}</p>}
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <div className="lg:w-96">
                                                            <input
                                                                type="text"
                                                                placeholder="51XXXX-XXX-XXX"
                                                                className="p-2 w-full border border-gray-300 rounded"
                                                                value={clavePredio}
                                                                onChange={(e) => setClavePredio(e.target.value)}
                                                            />
                                                        </div>
                                                        <Button onClick={handleBuscar}>Buscar</Button>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                        {searchType === "search_by_name" && (
                                            <>
                                                <section id="find_by_name">
                                                    <div
                                                        className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                        <div>
                                                            <h1 className="font-bold text-lg">BUSQUEDA POR NOMBRE</h1>
                                                            <p className="text-sm text-gray-500">
                                                                Ingresa los datos del predio para buscar.
                                                            </p>
                                                        </div>
                                                        <div className="flex flex-wrap gap-2 items-center">
                                                            <input
                                                                type="text"
                                                                placeholder="Nombre"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Paterno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded"
                                                                value={pLastName}
                                                                onChange={(e) => setPLastName(e.target.value)}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Materno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded"
                                                                value={mLastName}
                                                                onChange={(e) => setMLastName(e.target.value)}
                                                            />
                                                            <Button onClick={handleBuscar}>Buscar</Button>
                                                        </div>
                                                    </div>
                                                </section>
                                            </>
                                        )}
                                    </div>
                                    {searchType === "search_by_name" && prediosList && (
                                        <div className="mt-8">
                                            {prediosList.length > 0 ? (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                                        Resultados de búsqueda
                                                    </h6>
                                                    <ul className="border p-4 rounded-md bg-white shadow">
                                                        {prediosList.map((predio, index) => (
                                                            <li
                                                                key={predio.parcel_code}
                                                                className={`flex justify-between items-center py-3 px-4 rounded-md cursor-pointer hover:bg-blue-gray-50 transition duration-200 ${
                                                                    index !== prediosList.length - 1 ? 'mb-2' : ''
                                                                }`}
                                                                onClick={() => handleSelectPredio(predio)}
                                                            >
                                                                <span className="text-gray-700 font-medium">
                                                                    <strong class="pr-2">{predio.parcel_code}</strong>
                                                                    <strong class="pl-2">{predio.road_name}{predio.ext_num ? " #" + predio.ext_num : ""}, {predio.neighborhood_name}, C.P. {predio.postal_code}</strong>
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 my-4 text-center">
                                                        No se encontraron coincidencias.
                                                    </h6>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}


                        {step !== 1 && (
                            <>
                                <h6 className="font-semibold uppercase text-gray-600 mb-2">
                                    PAGO DE PREDIAL
                                </h6>
                                <div className="bg-white p-5 border rounded-md mb-4">
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <h6 className="font-semibold">Clave Buscada:</h6>
                                            <p>{clavePredio}</p>
                                        </div>
                                        <Button
                                            className="mt-2 bg-red-700"
                                            onClick={() => setOpenResetDialog(true)}
                                            style={{marginLeft: 'auto'}}
                                        >
                                            Restablecer
                                        </Button>
                                    </div>

                                    <Dialog open={openResetDialog} handler={setOpenResetDialog}>
                                        <DialogHeader>Confirmación</DialogHeader>
                                        <DialogBody>¿Estás seguro de restablecer?</DialogBody>
                                        <DialogFooter>
                                            <Button
                                                variant="text"
                                                onClick={() => setOpenResetDialog(false)}
                                                className="mr-2"
                                            >
                                                Cancelar
                                            </Button>
                                            <Button
                                                className="bg-red-500 text-white"
                                                onClick={handleReset}
                                            >
                                                Confirmar
                                            </Button>
                                        </DialogFooter>
                                    </Dialog>
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <div>
                                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                                    Información del predio
                                </h6>
                                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                                    <div className="flex-grow border p-4 rounded-md w-full lg:w-1/2">
                                        {predio && (
                                            <table className="w-full min-w-max table-auto text-left">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Tipo de Predio:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.lot_location_type}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Propietario:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.name} {predio.parental_last_name} {predio.maternal_last_name}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Dirección:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.road_name}{predio.ext_num ? " #" + predio.ext_num : ""}, {predio.neighborhood_name}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Referencias:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.address_references}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Sup. Terreno:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.land_area}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Sup. Const:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.construction_area}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                    <div className="flex-grow border rounded-md w-full lg:w-1/2 min-h-[350px]">
                                        <MapComponentUx parcel_code={clavePredio} latitude={predio.latitude}
                                                        longitude={predio.longitude}/>
                                    </div>
                                </div>

                                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                                    Adeudos
                                </h6>

                                <table className="w-full min-w-[640px] table-auto">
                                    <thead>
                                    <tr>
                                        {["", "Año", "Bimestre", "Impuesto", "Imp. Univ.", "Recargos", "Subtotal", "Total"].map(
                                            (el) => (
                                                <th
                                                    key={el}
                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                >
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        {el}
                                                    </Typography>
                                                </th>
                                            )
                                        )}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(!adeudos || adeudos.length === 0) ? (
                                        <Typography
                                            variant="normal"
                                            color="blue-gray"
                                            className="font-bold text-center"
                                        >
                                            El predio no tiene adeudos.
                                        </Typography>
                                    ) : (adeudos.map((adeudo, index) => {
                                            const className = `py-3 px-5 ${
                                                index === adeudos.length - 1 ? "" : "border-b border-blue-gray-50"
                                            }`;
                                            return (
                                                <tr key={adeudo.id} className="hover:bg-gray-50 cursor-pointer">
                                                    <td className={className}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedAdeudos.some(
                                                                (item) => item.id === adeudo.id
                                                            )}
                                                            onChange={() => toggleAdeudo(adeudo)}
                                                        />
                                                    </td>
                                                    <td className={className}>{adeudo.year}</td>
                                                    <td className={className}>{adeudo.bimester}</td>
                                                    <td className={className}>${adeudo.tax.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.university_tax.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.surcharge.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.subtotal.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.total.toFixed(2)}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                    </tbody>
                                </table>

                                {(adeudos && adeudos.length > 0) && (
                                    <div className="mt-4 flex flex-col items-end">
                                        <h6 className="font-semibold text-gray-600">
                                            Redondeo: ${(totalSelectedRounded - totalSelected.toFixed(2)).toFixed(2)}
                                        </h6>
                                        <h6 className="font-semibold text-gray-600">
                                            Total a pagar: ${totalSelectedRounded.toFixed(2)}
                                        </h6>
                                        <Button
                                            className="bg-blue-500 text-white rounded-md px-8 py-3 mt-4 text-lg"
                                            onClick={handlePagar}
                                        >
                                            PAGAR
                                        </Button>
                                    </div>
                                )}
                                <Dialog open={openWarningDialog} handler={setOpenWarningDialog}>
                                    <DialogHeader>Advertencia</DialogHeader>
                                    <DialogBody>
                                        <Typography>
                                            Por favor, selecciona al menos un adeudo para continuar con el pago.
                                        </Typography>
                                    </DialogBody>
                                    <DialogFooter>
                                        <Button
                                            className="bg-blue-500 text-white"
                                            onClick={() => setOpenWarningDialog(false)}
                                        >
                                            Aceptar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        )}

                        {step === 3 && (
                            <div>
                                <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                    Confirmar pago
                                </h6>
                                <table className="w-full min-w-[640px] table-auto">
                                    <thead>
                                    <tr>
                                        {["Año", "Bimestre", "Impuesto", "Imp. Univ.", "Recargos", "Subtotal", "Total"].map(
                                            (el) => (
                                                <th
                                                    key={el}
                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                >
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        {el}
                                                    </Typography>
                                                </th>
                                            )
                                        )}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(selectedAdeudos.map((adeudo, index) => {
                                            const className = `py-3 px-5 ${
                                                index === selectedAdeudos.length - 1 ? "" : "border-b border-blue-gray-50"
                                            }`;
                                            return (
                                                <tr key={adeudo.id} className="hover:bg-gray-50 cursor-pointer">
                                                    <td className={className}>{adeudo.year}</td>
                                                    <td className={className}>{adeudo.bimester}</td>
                                                    <td className={className}>${adeudo.tax.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.university_tax.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.surcharge.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.subtotal.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.total.toFixed(2)}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                    </tbody>
                                </table>

                                <div className="mt-4 flex flex-col items-end">
                                    <h6 className="font-semibold text-gray-600">
                                        Redondeo: ${(Math.ceil(totalSelected) - totalSelected.toFixed(2)).toFixed(2)}
                                    </h6>
                                    <h6 className="font-semibold text-gray-600">
                                        Total a pagar: ${totalSelectedRounded.toFixed(2)}
                                    </h6>
                                    <Button
                                        className="bg-blue-500 text-white rounded-md px-8 py-3 mt-4 text-lg"
                                        onClick={handlePagar}
                                    >
                                        PAGAR
                                    </Button>
                                </div>

                                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                                    Método de pago
                                </h6>
                                <div className="flex gap-4 mt-2">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            value="efectivo"
                                            onChange={(e) => setPaymentMethod(e.target.value)}
                                        />
                                        Efectivo
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            value="tarjeta"
                                            onChange={(e) => setPaymentMethod(e.target.value)}
                                        />
                                        Tarjeta
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            value="cheque"
                                            onChange={(e) => setPaymentMethod(e.target.value)}
                                        />
                                        Cheque
                                    </label>
                                </div>

                                {paymentMethod === "efectivo" && (<div className="mt-4">
                                        <div className="flex gap-4">
                                            <div className="w-full">
                                                <label htmlFor="recibido"
                                                       className="block text-sm font-medium text-gray-700 mb-1">Cantidad
                                                    recibida</label>
                                                <input
                                                    id="recibido"
                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md"
                                                    placeholder="Cantidad recibida"
                                                    type="number"
                                                    value={recibido}
                                                    onChange={(e) => setRecibido(Number(e.target.value))}
                                                />
                                            </div>

                                            <div className="w-full">
                                                <label
                                                    className="block text-sm font-medium text-gray-700 mb-1">Cobrado</label>
                                                <div className="w-full px-3 py-2 border border-gray-200 rounded-md">
                                                    ${totalSelectedRounded.toFixed(2)}
                                                </div>
                                            </div>

                                            <div className="w-full">
                                                <label
                                                    className="block text-sm font-medium text-gray-700 mb-1">Cambio</label>
                                                <div className="w-full px-3 py-2 border border-gray-200 rounded-md">
                                                    ${calcularCambio()}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-col items-end mt-4">
                                            <Button
                                                className="bg-green-500 text-white rounded-md px-8 py-3 text-lg"
                                                onClick={() => alert("Pago confirmado en efectivo")}
                                            >
                                                PAGAR
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {paymentMethod === "tarjeta" && (
                                    <div className="mt-4">
                                        <div className="border p-4 rounded-md">
                                            <p>Total a pagar: <strong>${totalSelectedRounded.toFixed(2)}</strong></p>
                                        </div>

                                        <div className="flex flex-col items-end mt-4">
                                            <Button
                                                className="bg-green-500 text-white rounded-md px-8 py-3 text-lg"
                                                onClick={handlePayment}
                                            >
                                                PAGAR
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {paymentMethod === "cheque" && (
                                    <div className="mt-4">
                                        <div className="border p-4 rounded-md">
                                            <p>Total a pagar: <strong>${totalSelectedRounded.toFixed(2)}</strong></p>
                                        </div>

                                        <div className="w-full">
                                            <label htmlFor="recibido"
                                                   className="block text-sm font-medium text-gray-700 mb-1">Cheque
                                                escaneado</label>
                                            <input
                                                id="recibido"
                                                className="w-full px-3 py-2 border border-gray-200 rounded-md"
                                                placeholder="Cantidad recibida"
                                                type="file"
                                            />
                                        </div>

                                        <div className="flex flex-col items-end mt-4">
                                            <Button
                                                className="bg-green-500 text-white rounded-md px-8 py-3 text-lg"
                                                onClick={() => alert("Pago confirmado con tarjeta")}
                                            >
                                                PAGAR
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <FooterUx/>
            </div>
        </>
    )
        ;
};

export default Payments;


